// ImageProctoring.jsx - Node 20 Version with Backend APIs
import React, { useState, useEffect, useRef } from "react";
import { Camvas } from "@msvargas97/pico.js";
import axios from "../../utils/axiosConfig";
import MuiAlert from "@mui/lab/Alert";
import ImageAlertModal from "./ImageAlertModal";
// import AudioAlertModal from "./AudioAlertModal";
// import BackgroundAudioRecorder from "./BackgroundAudioRecorder";
import NoFaceModal from './NoFaceModal';
import CameraFailedModal from './CameraFailedModal';
import PhotoNotSentModal from './PhotoNotSentModal';
import NoMatchModal from './NoMatchModal';
import MultipleFaceModal from './MultipleFaceModal';
import ObjectDetectionModal from './ObjectDetectionModal';
import LookingAwayModal from './LookingAwayModal';
import saveToMongoFunction from "../../utils/saveToMongoFunction";
import { isFaceNotFoundBudgetExceeded } from "../../utils/faceNotFoundBudget";
import { questionAllowsHeadphones } from "../../utils/headphonesAllowed";
import {
  PROCTORING_CAMERA_CONSTRAINTS,
  ANALYSIS_FRAME_LONG_SIDE,
  STORED_FRAME_LONG_SIDE,
  drawVideoFrame,
  drawScaledCopy,
} from "../../utils/sharedCamera";

// eslint-disable-next-line unused-imports/no-unused-vars
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ImagEProctoring(props) {
  const shapeRef = useRef();
  const withPupilsRef = useRef();
  const camvas = useRef("Start");

  const {
    examDetail,
    _setProcteringError,
    _setModelShow,
    ImageAlertShowModal,
    setImageAlertShowModal,
    AudioAlertShowModal,
    setAudioAlertShowModal,
    NoFaceAlertModal,
    setNoFaceAlertModal,
    _facialSentiments,
    _setFacialSentiments,
    NoMatchAlertModal,
    setNoMatchAlertModal,
    MultipleFaceAlertModal,
    setMultipleFaceAlertModal,
    ObjectDetectedAlertModal,
    setObjectDetectedAlertModal,
    _objectsDetected,
    setObjectsDetected,
    _objectsCount,
    setObjectsCount,
    primaryImage,
    setprimaryImage: setPrimaryImageFromServer,
    referenceFromServer,
    setProctoringEnd,
    _ProctoringEnd,
    isMongoUpdated,
    setisMongoUpdated,
    MonitoringData,
    _ProctoringProblem,
    _setProctoringProblem,
    examId,
    setWindowSwitch,
    setTestData,
    windowSwitchCount,
    faceNotFoundCount,
    setFaceNotFoundCount,
    testData,
    setFacialDataArray,  // ✅ Passed from parent
    isVideoUploading,  // ✅ New prop to pause proctoring during video upload
    questionNo,  // ✅ Current question number
    isRecording,  // ✅ True while VideoInterview is actively recording
    recordingVideoRef,  // ✅ Live <video> element from VideoInterview's recording, shared so
    // proctoring can borrow a frame from it instead of racing it for a second camera stream
    sharedCameraStreamRef,  // Set here to the exam's camera stream, for VideoInterview to record from
    recordingOnSharedCameraRef,  // True while VideoInterview records from that shared stream
    setIsPhotoMatchingInProgress,
    setIsPhotoServerPaused,  // Pauses the test timer while photos fail because of our server
    photoMismatchCount,
    setPhotoMismatchCount,
    setMultipleFaceCount,
    setObjectDetectedCount,
    setLookingAwayCount,
    finalPhotoRef,  // Set here to finalPhotoCheck, which Test.jsx runs when the test is submitted
  } = props;

  // Looking Away switch (MonitoringData.result.looking_away): the video service checks each photo
  // (Gemini decides, our own face model is logged beside it). A warning needs 2 of 3 photos taken
  // LOOKING_AWAY_CONFIRM_MS apart (a glance at the keyboard doesn't last that long), and the same
  // warning isn't given or counted again within LOOKING_AWAY_GAP_MS.
  const LOOKING_AWAY_CONFIRM_MS = 2000;
  const LOOKING_AWAY_GAP_MS = 60000;
  const [LookingAwayAlertModal, setLookingAwayAlertModal] = useState(false);
  const lastLookingAwayWarningAtRef = useRef(0);
  // When the candidate last typed, clicked or moved the mouse: sent with each photo and logged, so
  // looking down while typing can later be told apart from reading a phone.
  const lastInputAtRef = useRef(Date.now());
  useEffect(() => {
    const onInput = () => {
      lastInputAtRef.current = Date.now();
    };
    const events = ["keydown", "mousedown", "mousemove", "wheel", "touchstart"];
    events.forEach((e) => document.addEventListener(e, onInput, { passive: true }));
    return () => events.forEach((e) => document.removeEventListener(e, onInput));
  }, []);

  const _closeInstruction = () => {
    window.location.reload(false);
  };

  let captureIntervalId;
  let captureImageInterval = MonitoringData.result.photo_timer * 1000;

  let _flag = true;

  const [_snapShow, setSnapShow] = React.useState(true);
  const [_open, setOpen] = React.useState(false);
  const [_modal, setModal] = React.useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_message, setMessage] = React.useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_countFace, setCountFace] = React.useState(0);
  const [_hidden, setHidden] = React.useState(false);
  const [AudioCount, setAudioCount] = React.useState(0);
  const [IntervalOn, setIntervalOn] = React.useState(true);
  const [intervalCount, setIntervalCount] = useState(0);
  const [check, setcheck] = useState(true);

  // Require 2 consecutive detections before showing alert to suppress false positives
  const CONSECUTIVE_THRESHOLD = 2;
  const multipleFaceCountRef = useRef(0);
  const objectDetectedCountRef = useRef(0);
  const noFaceCountRef = useRef(0);
  // Covered face (video backend face_covered): covered continuously for
  // REACT_APP_FACE_COVERED_REVIEW_SECONDS (env; missing = off) -> that photo is saved once per attempt
  // as 'faceCovered' for reviewers. No popup and not counted. Short covering is common and innocent
  // (hand on the chin, looking down: 5% of real single-face photos score low); a minute straight is
  // a covered camera, a mask or a face cut off by the camera angle - production 22-29 Sep: 1.9% of
  // attempts.
  const coveredSinceRef = useRef(null);
  const coveredRecordedRef = useRef(false);
  // Camera covered (staging staff test 22 Oct 2026: a hand over the lens still reads as one face with
  // a very low score, so covering it warned only after minutes, or never): face covered, too dark or
  // out of frame on REACT_APP_FACE_COVERED_WARN_AFTER photo checks in a row is warned and counted as
  // face not visible. A face turned away is left to Looking Away. Env only: missing = off.
  const FACE_COVERED_WARN_AFTER = Number(process.env.REACT_APP_FACE_COVERED_WARN_AFTER) > 0 ? Number(process.env.REACT_APP_FACE_COVERED_WARN_AFTER) : null;
  const faceCoveredStreakRef = useRef(0);
  const noMatchCountRef = useRef(0);
  // Face found but not clear enough to compare with the reference photo (too close, cut off by the
  // frame, partly covered): one such photo means nothing, so it is never a mismatch. But a whole
  // stretch of them left the candidate unverified with every photo saved as a routine capture
  // (production 30 Sep: 19 photos in a row of someone else's face held close to the camera). After
  // REACT_APP_FACE_UNVERIFIED_WARN_AFTER photo checks in a row like that, it is warned and counted
  // as face not visible. Only photos whose similarity is below
  // REACT_APP_FACE_UNVERIFIED_MAX_SIMILARITY count towards the run: unclear photos that nearly
  // match are usually the real candidate (5 days of production + HDFC: 8% of attempts would be
  // warned without this limit, 1% with it at 0.5). Env only: either missing = off.
  const FACE_UNVERIFIED_WARN_AFTER = Number(process.env.REACT_APP_FACE_UNVERIFIED_WARN_AFTER) > 0 ? Number(process.env.REACT_APP_FACE_UNVERIFIED_WARN_AFTER) : null;
  const FACE_UNVERIFIED_MAX_SIMILARITY = Number(process.env.REACT_APP_FACE_UNVERIFIED_MAX_SIMILARITY) > 0 ? Number(process.env.REACT_APP_FACE_UNVERIFIED_MAX_SIMILARITY) : null;
  const FACE_UNVERIFIED_CHECK_ON = FACE_UNVERIFIED_WARN_AFTER !== null && FACE_UNVERIFIED_MAX_SIMILARITY !== null;
  const faceUnverifiedStreakRef = useRef(0);
  // Photos not reaching the server (HDFC 28 Sep: a whole 24-minute test with only the reference
  // photo - the browser sent nothing until submit). After REACT_APP_PHOTO_UNSENT_BLOCK_AFTER photo
  // checks in a row that got no answer from the server (network error, or the frame could not be
  // captured), or no answer for that many photo intervals at all (the photo loop stuck), the test
  // is blocked (PhotoNotSentModal) and a photo is retried every REACT_APP_PHOTO_UNSENT_RETRY_SECONDS
  // until one goes through. Env only: either missing = off.
  const PHOTO_UNSENT_BLOCK_AFTER = Number(process.env.REACT_APP_PHOTO_UNSENT_BLOCK_AFTER) > 0 ? Number(process.env.REACT_APP_PHOTO_UNSENT_BLOCK_AFTER) : null;
  const PHOTO_UNSENT_RETRY_MS = Number(process.env.REACT_APP_PHOTO_UNSENT_RETRY_SECONDS) > 0 ? Number(process.env.REACT_APP_PHOTO_UNSENT_RETRY_SECONDS) * 1000 : null;
  const PHOTO_UNSENT_CHECK_ON = PHOTO_UNSENT_BLOCK_AFTER !== null && PHOTO_UNSENT_RETRY_MS !== null;
  const photoUnsentCountRef = useRef(0);
  const lastPhotoAnsweredAtRef = useRef(Date.now());
  const [photoNotSent, setPhotoNotSent] = useState(false);
  // Why the photos are not getting through: "network" (no answer at all - the candidate's side)
  // or "server" (our server answered with an error - the face check or the photo save failed, as
  // in the HDFC 1 Oct outage where every photo save failed while the face checks still passed).
  const [photoNotSentCause, setPhotoNotSentCause] = useState("network");
  // The last regular photo save failed. Only a later save that works clears the block then: the
  // face check answering does not mean photos are being stored.
  const photoSaveFailedRef = useRef(false);
  // A server-side block is not the candidate's fault, so the test timer is paused while it lasts:
  // at most REACT_APP_PHOTO_SERVER_PAUSE_MAX_BLOCK_SECONDS per block (then the candidate is asked
  // to resume later from the dashboard, remaining time kept) and
  // REACT_APP_PHOTO_SERVER_PAUSE_MAX_TOTAL_SECONDS per attempt (then the timer runs while blocked,
  // as for a network block). Used time is kept on examDetail[0] so it survives a resume.
  // Env only: either missing = off (a server-side block keeps the timer running).
  const PHOTO_SERVER_PAUSE_MAX_BLOCK_MS = Number(process.env.REACT_APP_PHOTO_SERVER_PAUSE_MAX_BLOCK_SECONDS) > 0 ? Number(process.env.REACT_APP_PHOTO_SERVER_PAUSE_MAX_BLOCK_SECONDS) * 1000 : null;
  const PHOTO_SERVER_PAUSE_MAX_TOTAL_MS = Number(process.env.REACT_APP_PHOTO_SERVER_PAUSE_MAX_TOTAL_SECONDS) > 0 ? Number(process.env.REACT_APP_PHOTO_SERVER_PAUSE_MAX_TOTAL_SECONDS) * 1000 : null;
  const PHOTO_SERVER_PAUSE_ON = PHOTO_SERVER_PAUSE_MAX_BLOCK_MS !== null && PHOTO_SERVER_PAUSE_MAX_TOTAL_MS !== null;
  // "none" | "paused" (timer paused) | "running" (per-attempt pause used up) | "expired" (this
  // block reached its limit - resume later from the dashboard).
  const [serverPauseState, setServerPauseState] = useState("none");
  const serverPauseStartedAtRef = useRef(null);

  // Performance: in-flight guard prevents concurrent API calls on slow connections
  const apiInFlightRef = useRef(false);
  // A photo arrived while a check was running: its check used to be dropped (staging 22 Oct: 32 of
  // 103 photos checked, so warnings came minutes late). Now the newest frame is checked as soon as the
  // running check has finished - no extra stored photo, and never while a warning is on screen.
  const checkPendingRef = useRef(false);
  // Photos and checks are separate: every Photo Click Timer tick takes a photo and saves it (the
  // timed photo), whatever the checks find; a check runs on it only when no check is running and no
  // warning is on screen - checks only raise warnings. Before, a photo was saved only after its
  // check answered, so ticks during a running check were dropped (a 5 s timer gave ~15 s between
  // photos - prod 19 Oct, attempt 971768), a failed check saved nothing, and no photo was taken
  // while a warning was on screen.
  const captureInProgressRef = useRef(false);
  const intervalOnRef = useRef(true);
  // Reused off-DOM canvases: the frame sent for analysis (up to ANALYSIS_FRAME_LONG_SIDE) and
  // the smaller copy stored as the proctoring photo (up to STORED_FRAME_LONG_SIDE).
  const analysisCanvasRef = useRef(null);
  const storedCanvasRef = useRef(null);
  // Reused tiny offscreen canvas the frame-variance check below downscales each capture onto -
  // representing the whole frame instead of one fixed corner (see comment at its usage).
  const varianceSampleCanvasRef = useRef(null);
  // Performance: track whether primary image is cached server-side
  const primaryRegisteredRef = useRef(false);
  // Unusable reference photo ("R"): first reload the server's copy; if that is unusable too,
  // treat "R" like a system error (retry next cycle, no popup) - see handleUnusableReference.
  const referenceReloadRef = useRef("idle"); // idle | reloading | reloaded | gave_up
  const sessionKey = String(examDetail[0]?.id || "");
  // Headphones/neckbands are needed on video-interview, speaking and listening questions (see
  // utils/headphonesAllowed.js), so the video service is told not to flag them while one is on
  // screen. Read through a ref so a capture scheduled on an earlier render still sees the
  // current question.
  const headphonesAllowedRef = useRef(false);
  headphonesAllowedRef.current = questionAllowsHeadphones(Array.isArray(testData) ? testData[questionNo - 1] : null);

  // Set when getUserMedia has rejected and bounded retries in startCamvas are exhausted, so
  // the black-frame check in saveImage() can skip straight to restartCamvasStream() instead of
  // wasting a pixel-sampling loop confirming what we already know failed outright.
  const camvasStreamFailedRef = useRef(false);
  // Lets the unmount cleanup cancel a pending startCamvas retry so it can't re-acquire the
  // camera after the component is gone.
  const camvasRetryTimeoutRef = useRef(null);
  // Hard block (no dismiss, no "continue anyway") shown when the camera never opens at all -
  // see CameraFailedModal. Only way out is Retry Camera, or - once
  // MAX_CAMERA_FAILURE_CYCLES is exhausted - the terminal "device not compatible" state,
  // which sends the candidate back to the dashboard WITHOUT aborting the exam or recording a
  // proctoring violation, so they can attempt the same test again on a working device.
  const [cameraFailedModalOpen, setCameraFailedModalOpen] = React.useState(false);
  const [cameraFailureTerminal, setCameraFailureTerminal] = React.useState(false);
  const cameraFailureCycleCountRef = useRef(0);
  const MAX_CAMERA_FAILURE_CYCLES = 3;

  const _handleClick = () => {
    setOpen(true);
  };

  const _handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setModal(false);
  };

  // Register primary image with the backend once on mount so it doesn't need
  // to be sent on every subsequent frame capture (saves ~50% bandwidth per call).
  // Proxied through v2-user-backend (not called directly) so the face-analysis
  // microservice credential stays server-side — see faceAnalysisProxy.js.
  //
  // A resumed exam loads the server's copy of the ORIGINAL reference photo (Test.jsx ->
  // sendPrimaryImage); wait for it rather than register whatever is in localStorage, which on a
  // resume is the resume photo - registering that made every later photo compare with whoever
  // resumed. Re-registers when the server copy arrives. A fresh start registers the photo just
  // taken: it must not wait on status "001" (set by starting the exam), or it never registers.
  useEffect(() => {
    const waitForServerCopy = referenceFromServer === true && !primaryImage;
    const img1Src = primaryImage || (waitForServerCopy ? null : localStorage.getItem('primaryimage'));
    if (!img1Src || !sessionKey) return;
    primaryRegisteredRef.current = false;
    axios.post(
      `/test/proctoring/register-primary`,
      { sessionKey, primaryImage: img1Src.split(",")[1] },
      { timeout: 20000 }
    ).then(() => { primaryRegisteredRef.current = true; })
      .catch((err) => {
        // Fall back to sending primary image each call for network/timeout
        // errors. But if the reference photo itself is invalid (no face /
        // multiple faces), every per-frame match below will keep failing the
        // same way for the rest of the exam — surface it once now instead of
        // letting the candidate discover it only through repeated violation
        // modals with no indication of the actual cause.
        const registerError = err.response && err.response.data && err.response.data.error;
        if (registerError === "No face detected in primary image") {
          setIntervalOn(false);
          setNoFaceAlertModal(true);
        } else if (registerError === "Multiple faces detected in primary image") {
          setIntervalOn(false);
          setMultipleFaceAlertModal(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryImage]);

  // Audio recording is now handled by BackgroundAudioRecorder component

  const reduceImageSize = async (imageSrc) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imageSrc;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const reducedImage = canvas.toDataURL('image/jpeg', 0.8);
        resolve(reducedImage);
      };
      img.src = imageSrc;
    });
  };

  function formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear() % 100;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedYear = year.toString().padStart(2, '0');
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedDateTime = `${formattedDay}${formattedMonth}${formattedYear}${formattedHours}${formattedMinutes}`;
    return formattedDateTime;
  }

  // getaudio function removed - replaced by BackgroundAudioRecorder component

  // BACKEND API FACE DETECTION - Replaces frontend face-api.js
  // options.recordSentiment = false: used for confirmation frames (see saveImage), so a
  // violation check doesn't add extra entries to the candidate's emotion timeline.
  // options.burstId / burstIndex: groups a capture's first frame (0) with its confirmation
  // frames (1, 2) so the server can make the same 2-of-3 decision (shadow mode, logged only).
  const detectFaces2 = async (img2, options = {}) => {
    const recordFacialData = options.recordSentiment === false ? () => {} : setFacialDataArray;
    return new Promise(async (resolve) => {
      let isMatch = false;
      let error;
      let faceCount;
      let expression1 = "Unknown";
      let expression2 = "Unknown";
      const threshold = 0.2;
      let objectsDetected = [];
      let objectsCount = 0;

      let img1Src = primaryImage || localStorage.getItem('primaryimage');

      try {
        // Use sessionKey if primary image is cached server-side (saves ~50% bandwidth)
        // objectDetection tells the video service whether this exam uses object detection, so it
        // can skip its paid Gemini call when it doesn't.
        const objectDetection = MonitoringData.result.object_detection === true;
        // userexamid attributes the frame in the server-side score log even before the
        // reference photo is cached (when sessionKey isn't sent).
        const userexamid = examDetail[0]?.id;
        const headphonesAllowed = headphonesAllowedRef.current;
        const { burstId, burstIndex } = options;
        const lookingAway = MonitoringData.result.looking_away === true;
        const inputIdleMs = Date.now() - lastInputAtRef.current;
        const payload = primaryRegisteredRef.current && sessionKey
          ? { sessionKey, currentImage: img2.src.split(",")[1], objectDetection, headphonesAllowed, lookingAway, inputIdleMs, userexamid, burstId, burstIndex }
          : { primaryImage: img1Src.split(",")[1], currentImage: img2.src.split(",")[1], objectDetection, headphonesAllowed, lookingAway, inputIdleMs, userexamid, burstId, burstIndex };

        let response = await axios.post(
          `/test/proctoring/face-match`,
          payload,
          { timeout: 15000 }
        );

        // Fallback for invalid primary image format
        if (response.data.isMissingCachedPrimaryImage) {
          response = await axios.post(
            `/test/proctoring/face-match`,
            { primaryImage: img1Src.split(",")[1], currentImage: img2.src.split(",")[1], objectDetection, headphonesAllowed, lookingAway, inputIdleMs, userexamid, burstId, burstIndex },
            { timeout: 15000 }
          );
        }

        // The server got the same picture as minutes ago: the camera has stopped (user backend
        // utils/frameLiveness.js). Reopen it so the next photo is live; this photo is checked as usual.
        if (response.data && response.data.camera_frozen) restartCamvasStream();

        const {
          success,
          face_match,
          _similarity_score,
          primary_image_analysis,
          current_image_analysis,
          error_message,
          step,
        } = response.data;

        console.log("response.data", response.data)

        // The backend includes object detection in face-failure responses too (e.g. "Face not
        // clearly visible"). Honor it first so a detected phone isn't masked by a face error;
        // it falls through to the object block below.
        const objectFlagged = !!(current_image_analysis && current_image_analysis.object_detected && current_image_analysis.objects_count > 0);

        if (!success && !objectFlagged) {
          // Handle face detection errors
          if (error_message === "No face detected in primary image" || error_message === "No face detected in current image") {
            error = "N";
            faceCount = 0;
            // Add neutral sentiments when no face detected
            recordFacialData((prev) => [
              ...prev,
              {
                timestamp: new Date().toISOString(),
                sentiments: {
                  neutral: 0,
                  happy: 0,
                  sad: 0,
                  angry: 0,
                  fearful: 0,
                  disgusted: 0,
                  surprised: 0,
                },
              },
            ]);
            resolve({
              result: false,
              error: error,
              faceCount: faceCount,
              expression1: "Unknown",
              expression2: "Unknown",
              objectsDetected,
              objectsCount,
            });
            return;
          } else if (error_message === "Multiple faces detected in primary image. Please use an image with only one face" ||
            error_message === "Multiple faces detected in current image. Please use an image with only one face") {
            error = "M";
            faceCount = current_image_analysis.face_count || primary_image_analysis.face_count || 2;
            // Add neutral sentiments when multiple faces
            recordFacialData((prev) => [
              ...prev,
              {
                timestamp: new Date().toISOString(),
                sentiments: {
                  neutral: 0,
                  happy: 0,
                  sad: 0,
                  angry: 0,
                  fearful: 0,
                  disgusted: 0,
                  surprised: 0,
                },
              },
            ]);
            resolve({
              result: false,
              error: error,
              faceCount: faceCount,
              expression1: "Unknown",
              expression2: "Unknown",
              objectsDetected,
              objectsCount,
            });
            return;
          } else {
            console.error("API error:", error_message, "at step:", step);
            error = "N";
            faceCount = 0;
            recordFacialData((prev) => [
              ...prev,
              {
                timestamp: new Date().toISOString(),
                sentiments: {
                  neutral: 0,
                  happy: 0,
                  sad: 0,
                  angry: 0,
                  fearful: 0,
                  disgusted: 0,
                  surprised: 0,
                },
              },
            ]);
            resolve({
              result: false,
              error: error,
              faceCount: faceCount,
              expression1: "Unknown",
              expression2: "Unknown",
              objectsDetected,
              objectsCount,
            });
            return;
          }
        }

        // Check for object detection in current image
        if (current_image_analysis.object_detected && current_image_analysis.objects_count > 0) {
          error = "O";
          faceCount = current_image_analysis.face_count;
          objectsDetected = current_image_analysis.object_names;
          objectsCount = current_image_analysis.objects_count || 0;

          // Still process facial expressions if face is detected
          if (primary_image_analysis.face_detected && primary_image_analysis.analysis.expressions) {
            const _primaryExpressions = primary_image_analysis.analysis.expressions.all_emotions.reduce((acc, { emotion, confidence }) => {
              acc[emotion] = confidence;
              return acc;
            }, {});
            expression1 = primary_image_analysis.analysis.expressions.dominant_emotion;
            if (primary_image_analysis.analysis.expressions.confidence < threshold) {
              expression1 = "Unknown";
            }
          }

          if (current_image_analysis.face_detected && current_image_analysis.analysis.expressions) {
            const currentExpressions = current_image_analysis.analysis.expressions.all_emotions.reduce((acc, { emotion, confidence }) => {
              acc[emotion] = confidence;
              return acc;
            }, {});

            // ✅ Add facial sentiments to array
            recordFacialData((prev) => [
              ...prev,
              {
                timestamp: new Date().toISOString(),
                sentiments: currentExpressions,
              },
            ]);

            expression2 = current_image_analysis.analysis.expressions.dominant_emotion;
            if (current_image_analysis.analysis.expressions.confidence < threshold) {
              expression2 = "Unknown";
            }
          } else {
            recordFacialData((prev) => [
              ...prev,
              {
                timestamp: new Date().toISOString(),
                sentiments: {
                  neutral: 0,
                  happy: 0,
                  sad: 0,
                  angry: 0,
                  fearful: 0,
                  disgusted: 0,
                  surprised: 0,
                },
              },
            ]);
          }

          resolve({
            result: false, // Object detected means not a valid match
            error: error,
            faceCount: faceCount,
            expression1: expression1,
            expression2: expression2,
            objectsDetected,
            objectsCount,
          });
          return;
        }

        // Normal face matching flow
        isMatch = face_match;
        // Against the reference photo alone (similarity_primary). similarity_score is the
        // service's decision score: in its adaptive mode, the best of the reference and the
        // candidate's own extra photos - another person's face held close scored just over the
        // limit against those (staging 6 Oct: 0.42 vs the reference, 0.53 best), resetting the run.
        const unverifiedSimilarity =
          typeof response.data.similarity_primary === "number" ? response.data.similarity_primary : response.data.similarity_score;
        // identity_engine "sface": SFace decided face_match and its own reliability (video backend
        // FACE_FRAME_MODE=enforce); the similarity scores are still Human's, so they don't apply.
        const sfaceIdentity = response.data.identity_engine === "sface";
        const faceUnverified =
          FACE_UNVERIFIED_CHECK_ON &&
          face_match === false &&
          response.data.face_match_reliable === false &&
          (sfaceIdentity || (typeof unverifiedSimilarity === "number" && unverifiedSimilarity < FACE_UNVERIFIED_MAX_SIMILARITY));
        // The backend marks a failed match on a poor-quality frame (no facial landmarks, or a
        // near-miss on a face cut off / turned / dark / blurred) as unreliable. That is not
        // evidence of a different person, so don't treat it as a mismatch.
        if (face_match === false && response.data.face_match_reliable === false) {
          console.log("Face match unreliable on this frame, not treated as a mismatch:", current_image_analysis?.frame_quality?.issues);
          isMatch = true;
        }
        faceCount = current_image_analysis.face_count;

        // Process primary image expressions
        if (primary_image_analysis.face_detected && primary_image_analysis.analysis.expressions) {
          const _primaryExpressions = primary_image_analysis.analysis.expressions.all_emotions.reduce((acc, { emotion, confidence }) => {
            acc[emotion] = confidence;
            return acc;
          }, {});
          expression1 = primary_image_analysis.analysis.expressions.dominant_emotion;
          if (primary_image_analysis.analysis.expressions.confidence < threshold) {
            expression1 = "Unknown";
          }
        }

        // Process current image expressions
        if (current_image_analysis.face_detected && current_image_analysis.analysis.expressions) {
          const currentExpressions = current_image_analysis.analysis.expressions.all_emotions.reduce((acc, { emotion, confidence }) => {
            acc[emotion] = confidence;
            return acc;
          }, {});

          // ✅ Add facial sentiments to array
          recordFacialData((prev) => [
            ...prev,
            {
              timestamp: new Date().toISOString(),
              sentiments: currentExpressions,
            },
          ]);

          expression2 = current_image_analysis.analysis.expressions.dominant_emotion;
          if (current_image_analysis.analysis.expressions.confidence < threshold) {
            expression2 = "Unknown";
          }
        } else {
          recordFacialData((prev) => [
            ...prev,
            {
              timestamp: new Date().toISOString(),
              sentiments: {
                neutral: 0,
                happy: 0,
                sad: 0,
                angry: 0,
                fearful: 0,
                disgusted: 0,
                surprised: 0,
              },
            },
          ]);
        }

        // Handle no face detected
        if (!primary_image_analysis.face_detected || !current_image_analysis.face_detected) {
          faceCount = 0;
          error = "N";
        } else if (faceCount >= 2) {
          error = "M";
        }

        resolve({
          result: isMatch,
          error: error,
          faceCount: faceCount,
          expression1: expression1,
          expression2: expression2,
          objectsDetected,
          objectsCount,
          // One face, but mostly covered (camera blocked below the eyes, hand over the face):
          // recorded for reviewers only - see recordCoveredFace.
          faceCovered: faceCount === 1 && (current_image_analysis.face_covered === true || current_image_analysis.face_hidden === true),
          // Why the face can't be seen (video backend face_hidden_reason): covered | out_of_frame |
          // too_dark | turned_away. Older backends only send face_covered.
          faceHiddenReason: current_image_analysis.face_hidden_reason || (current_image_analysis.face_covered === true ? "covered" : null),
          // One face, but not clear enough to compare with the reference - see faceUnverifiedStreakRef.
          faceUnverified: faceCount === 1 && faceUnverified,
          // Looking Away switch: the video service's decision for this photo (one face only).
          lookingAway: faceCount === 1 && current_image_analysis.looking_away?.looking_away === true,
        });
      } catch (err) {
        // IMPORTANT: this executor has no `reject`, so every branch below MUST call
        // resolve(). A network error/timeout has no `err.response` at all — reading
        // `err.response.data` used to throw here, which left this promise unsettled
        // forever and permanently disabled proctoring for the rest of the exam
        // (saveImage()'s in-flight lock never released). Never assume `err.response` exists.
        console.error("Error in face matching:", err);

        const responseData = err.response && err.response.data;
        const errorMessage = responseData ? responseData.error_message : undefined;
        if (responseData && responseData.camera_frozen) restartCamvasStream();
        const primaryAnalysis = responseData && responseData.primary_image_analysis;
        const currentAnalysis = responseData && responseData.current_image_analysis;

        if (
          errorMessage === "Multiple faces detected in primary image. Please use an image with only one face" ||
          errorMessage === "Multiple faces detected in current image. Please use an image with only one face"
        ) {
          error = "M";
          faceCount = (currentAnalysis && currentAnalysis.face_count) || (primaryAnalysis && primaryAnalysis.face_count) || 2;
          recordFacialData((prev) => [
            ...prev,
            {
              timestamp: new Date().toISOString(),
              sentiments: {
                neutral: 0,
                happy: 0,
                sad: 0,
                angry: 0,
                fearful: 0,
                disgusted: 0,
                surprised: 0,
              },
            },
          ]);
          resolve({
            result: false,
            error: error,
            faceCount: faceCount,
            expression1: "Unknown",
            expression2: "Unknown",
            objectsDetected,
            objectsCount,
          });
          return;
        }

        if (errorMessage === "Invalid primary image format") {
          // This only fires after the isMissingCachedPrimaryImage retry above already
          // resent the raw reference photo and the backend still couldn't decode it - a
          // genuinely corrupted local copy, not a stale server cache. Retrying again would
          // fail identically every cycle, so this must not be reported as an ordinary
          // "no face" result: that would silently burn the candidate's face-not-found
          // abort budget for a system-side data problem that isn't their fault.
          console.error("Reference photo rejected by face-match service (invalid format) - not a face-not-found violation:", errorMessage);
          resolve({
            result: false,
            error: "R",
            faceCount: 0,
            expression1: "Unknown",
            expression2: "Unknown",
            objectsDetected,
            objectsCount,
          });
          return;
        }

        // A connectionless network/timeout failure (no err.response at all), or a 5xx from
        // the face-match microservice itself (model_loading/tensor_processing/face_embedding/
        // unknown - see v2-video-backend-20's statusForFaceMatchStep, which reserves 400 for
        // an actual client-side/genuine-no-face result and 500 for everything else) means the
        // system never actually produced a verdict on this frame. That must never be recorded
        // as the candidate's fault: same rationale as the "R" (corrupted reference photo) case
        // above, just for a different failure class.
        if (!err.response || err.response.status >= 500) {
          console.error(
            "Face-match system failure, not a face-not-found violation:",
            err.response ? `status ${err.response.status}${responseData && responseData.step ? `, step=${responseData.step}` : ""}` : err.message
          );
          resolve({
            result: false,
            error: "S",
            // No answer from the server at all: the photo never reached us (see markPhotoUnsent).
            unreachable: !err.response,
            faceCount: 0,
            expression1: "Unknown",
            expression2: "Unknown",
            objectsDetected,
            objectsCount,
          });
          return;
        }

        // Face failures come back as HTTP 400 but the body still carries object detection for
        // the frame. Surface a detected object (e.g. phone) instead of masking it behind a
        // generic "no face" result.
        if (currentAnalysis && currentAnalysis.object_detected && currentAnalysis.objects_count > 0) {
          recordFacialData((prev) => [
            ...prev,
            {
              timestamp: new Date().toISOString(),
              sentiments: {
                neutral: 0,
                happy: 0,
                sad: 0,
                angry: 0,
                fearful: 0,
                disgusted: 0,
                surprised: 0,
              },
            },
          ]);
          resolve({
            result: false,
            error: "O",
            faceCount: currentAnalysis.face_count || 0,
            expression1: "Unknown",
            expression2: "Unknown",
            objectsDetected: currentAnalysis.object_names || [],
            objectsCount: currentAnalysis.objects_count || 0,
          });
          return;
        }

        // Any remaining 4xx (a genuine no-face/other client-side result) falls back to a
        // neutral "no face" result so the caller always gets a resolved promise.
        error = "N";
        recordFacialData((prev) => [
          ...prev,
          {
            timestamp: new Date().toISOString(),
            sentiments: {
              neutral: 0,
              happy: 0,
              sad: 0,
              angry: 0,
              fearful: 0,
              disgusted: 0,
              surprised: 0,
            },
          },
        ]);
        resolve({
          result: isMatch,
          error: error,
          faceCount: 0,
          expression1: "Unknown",
          expression2: "Unknown",
          objectsDetected,
          objectsCount,
        });
      }
    });
  };

  // What kind of violation a detectFaces2 result represents (null = none). Mirrors the order
  // of the checks in saveImage so the confirmation burst compares like with like.
  // Env only: missing REACT_APP_FACE_COVERED_REVIEW_SECONDS = not recorded.
  const FACE_COVERED_REVIEW_MS = Number(process.env.REACT_APP_FACE_COVERED_REVIEW_SECONDS) > 0 ? Number(process.env.REACT_APP_FACE_COVERED_REVIEW_SECONDS) * 1000 : null;
  const markPhotoAnswered = () => {
    lastPhotoAnsweredAtRef.current = Date.now();
    if (photoSaveFailedRef.current) return;
    photoUnsentCountRef.current = 0;
    setPhotoNotSent(false);
  };
  const markPhotoUnsent = (cause = "network") => {
    // An error reply from our server still shows the photo loop is running, so the stuck-loop
    // watchdog below must not take this over as a network block.
    if (cause === "server") lastPhotoAnsweredAtRef.current = Date.now();
    photoUnsentCountRef.current += 1;
    if (PHOTO_UNSENT_CHECK_ON && photoUnsentCountRef.current >= PHOTO_UNSENT_BLOCK_AFTER) {
      setPhotoNotSentCause(cause);
      setPhotoNotSent(true);
    }
  };
  // Outcome of storing a regular photo (/test/saveImage). Any HTTP reply is our server's; no
  // reply at all is the connection.
  const markPhotoSaved = () => {
    photoSaveFailedRef.current = false;
    markPhotoAnswered();
  };
  const markPhotoNotSaved = (err) => {
    photoSaveFailedRef.current = true;
    markPhotoUnsent(err && !err.response ? "network" : "server");
  };
  // The timed photo, saved as a regular photo on every tick (see captureInProgressRef).
  const saveTimedPhoto = async (image) => {
    try {
      const image1 = await reduceImageSize(image);
      const resp = await axios.post("/test/saveImage", {
        headers: { "Access-Control-Allow-Origin": "*" },
        userid: examDetail[0].userid,
        userexamid: examDetail[0].id,
        instanceid: examDetail[0].instanceid,
        imagePath: image1,
        expression1: "Unknown",
        expression2: "Unknown",
        phototag: "regular",
      });
      if (resp.data.msg === "SUCCESS") {
        markPhotoSaved();
        setHidden(true);
      } else {
        markPhotoNotSaved();
        setHidden(false);
      }
    } catch (err) {
      markPhotoNotSaved(err);
      setHidden(false);
    }
  };
  const recordCoveredFace = async (covered, storedImage, hiddenReason = null) => {
    if (FACE_COVERED_REVIEW_MS === null) return;
    if (!covered) {
      coveredSinceRef.current = null;
      return;
    }
    if (coveredSinceRef.current === null) coveredSinceRef.current = Date.now();
    if (coveredRecordedRef.current || Date.now() - coveredSinceRef.current < FACE_COVERED_REVIEW_MS) return;
    coveredRecordedRef.current = true;
    try {
      const reduced = await reduceImageSize(storedImage);
      axios
        .post("/test/saveErrorImage", {
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: 1,
          // "R" = for review. Not "N": the backend records "N" as a no-face photo, and this one
          // counts as nothing. (Unrelated to detectFaces2's error "R", an unusable reference photo.)
          error: "R",
          imagePath: reduced,
          expression1: "Unknown",
          expression2: "Unknown",
          // Only a covered face is "faceCovered"; a face out of frame, in the dark or turned away is
          // "faceNotClear" (prod: most "covered" photos were faces half out of frame).
          phototag: hiddenReason && hiddenReason !== "covered" ? "faceNotClear" : "faceCovered",
        })
        .catch(() => { });
    } catch (e) {
      // best effort - reviewers only
    }
  };

  const violationKind = (r) => {
    if (!r || r.error === "S" || r.error === "R") return null;
    if (r.faceCount === 0) return "noFace";
    // A phone outranks a second face (a phone held to the ear was read as a face, hiding the phone),
    // and another person's face outranks looking away (staging staff test 22 Oct 2026).
    if (r.error === "O") return "object";
    if (MonitoringData.result.multiple_faces === true && r.faceCount >= 2) return "multipleFaces";
    if (MonitoringData.result.photo_matching === true && r.result === false) return "mismatch";
    if (MonitoringData.result.looking_away === true && r.lookingAway === true) return "lookingAway";
    return null;
  };

  const handleUnusableReference = () => {
    if (referenceReloadRef.current !== "idle") {
      if (referenceReloadRef.current === "reloaded") {
        referenceReloadRef.current = "gave_up";
        console.error("Server copy of the reference photo is unusable too - identity comparison paused; other checks retry each cycle.");
      }
      return;
    }
    referenceReloadRef.current = "reloading";
    axios
      .post("/test/sendPrimaryImage", { userid: examDetail[0].userid, userexamid: examDetail[0].id })
      .then((resp) => {
        const serverCopy = resp.data?.primaryImage?.imagepath;
        if (!serverCopy || typeof setPrimaryImageFromServer !== "function") throw new Error("no server copy");
        primaryRegisteredRef.current = false; // send the reloaded photo with the next frames
        setPrimaryImageFromServer(serverCopy);
        referenceReloadRef.current = "reloaded";
        console.warn("Reference photo was unusable - reloaded the server's copy of the original.");
      })
      .catch(() => {
        referenceReloadRef.current = "gave_up";
        console.error("Reference photo unusable and no server copy - identity comparison paused; other checks retry each cycle.");
      });
  };

  const saveImage = async (options) => {
    await captureAndCheck(options);
    if (checkPendingRef.current && !apiInFlightRef.current && intervalOnRef.current) {
      checkPendingRef.current = false;
      await saveImage({ checkOnly: true });
    }
  };
  // checkOnly: a check on a fresh frame for a photo whose check was skipped (see checkPendingRef);
  // the photo itself was already saved by its tick.
  const captureAndCheck = async ({ checkOnly = false } = {}) => {
    // Restart the interval cleanly after upload finishes instead of firing immediately
    if (isVideoUploading) {
      // Photos pause during a video upload - not a missing photo.
      lastPhotoAnsweredAtRef.current = Date.now();
      setIntervalCount(c => c + 1);
      return;
    }
    // One capture at a time (a capture can wait for a non-black frame).
    if (captureInProgressRef.current) return;
    captureInProgressRef.current = true;

    let img2, image;
    // Set when the corner-sample variance check below finds a near-perfectly-uniform frame -
    // some laptops' webcam drivers substitute a flat, synthetically-rendered "camera blocked"
    // placeholder (solid color + small icon graphic) into the getUserMedia stream itself when a
    // hardware privacy shutter is engaged, instead of the sensor going black. It's non-black so
    // it passes the black-frame check, but its icon graphic has just enough edge contrast to
    // make the AI face-matcher's embedding comparison swing unpredictably (seen in practice
    // oscillating between a confident match and a confident mismatch on the same static
    // placeholder), never landing on a clean "no face" or staying on "mismatch" for the
    // CONSECUTIVE_THRESHOLD frames needed to raise a violation - so no popup ever shows despite
    // the camera genuinely being blocked. Skip the AI entirely for this frame class instead.
    let isCameraBlockedPlaceholder = false;
    // Captures another frame from the same source as img2 (set below once the source is known);
    // used by the confirmation burst.
    let grabConfirmationFrame = null;
    try {
      // While a video-interview question is recording on its fallback path (its own camera
      // stream, not the shared one), borrow a frame straight from it instead of drawing from
      // Camvas's independent stream - the browser/OS can silently starve a second live consumer
      // of the same camera (producing black frames indefinitely) without ever erroring or
      // changing readyState. When the recording uses the shared camera there is only one stream,
      // so Camvas's frames stay live and are used as usual.
      const recordingOnSharedCamera = !!(recordingOnSharedCameraRef && recordingOnSharedCameraRef.current);
      const liveRecordingVideo = isRecording && !recordingOnSharedCamera && recordingVideoRef && recordingVideoRef.current;
      const usingLiveRecordingFrame = !!(liveRecordingVideo && liveRecordingVideo.readyState >= 2 && liveRecordingVideo.videoWidth > 0);

      // Frames are drawn straight from the live video at capture time, at the camera's own
      // aspect ratio (previously Camvas repainted a fixed, stretched 550x450 canvas on every
      // animation frame, which the browser pauses in background tabs).
      const sourceVideo = usingLiveRecordingFrame ? liveRecordingVideo : camvas.current && camvas.current.video;
      if (!analysisCanvasRef.current) analysisCanvasRef.current = document.createElement("canvas");
      if (!storedCanvasRef.current) storedCanvasRef.current = document.createElement("canvas");
      const imageSrc = analysisCanvasRef.current;
      const drawFrame = () => {
        if (drawVideoFrame(sourceVideo, imageSrc, ANALYSIS_FRAME_LONG_SIDE)) return true;
        // No frame available: blank the reused canvas so the previous capture is never sent
        // again as if it were current (a dead camera must still read as a black frame).
        const blankCtx = imageSrc.getContext("2d");
        blankCtx.fillStyle = "#000";
        blankCtx.fillRect(0, 0, imageSrc.width, imageSrc.height);
        return false;
      };

      if (usingLiveRecordingFrame) {
        drawFrame();
      }

      // Only Camvas's own stream can go black from stream contention/hiccups - a frame just
      // drawn from the live recording video above is already known-fresh.
      if (!usingLiveRecordingFrame) {
        // Verify canvas feed has actual non-black frame painted before capturing. A live stream's
        // next real frame shows up within a render tick or two (tens of ms) - BLACK_FRAME_MAX_RETRIES
        // just needs to cover a normal camera warm-up, not act as the recovery mechanism itself
        // (that's restartCamvasStream() below). Kept short so a truly dead stream gets restarted
        // quickly instead of stalling this capture cycle for seconds first.
        const checkCtx = imageSrc.getContext("2d");
        if (checkCtx) {
          const BLACK_FRAME_MAX_RETRIES = 5;
          const BLACK_FRAME_RETRY_INTERVAL_MS = 200;
          // startCamvas already exhausted its own retries and confirmed getUserMedia never
          // succeeded - sampling pixels here would just spend a second re-confirming a black
          // frame we already know is black, delaying the actual fix (restartCamvasStream).
          // A real optical capture - even of a plain wall - always carries sensor noise and
          // lighting variance; a driver-rendered placeholder frame's flat regions are pixel-
          // uniform. Conservative starting threshold - tune against real captured variance
          // values (logged below) once more devices with this behavior are seen.
          //
          // Measured across the WHOLE frame (downscaled onto a tiny offscreen canvas), not one
          // fixed corner - a single corner sample can't tell a genuine placeholder apart from a
          // real frame whose corner just happens to land on a plain wall/desk under even
          // lighting (webcams denoise flat areas aggressively enough that this reads as ~0
          // variance too - seen in practice, a real open-shutter face-visible frame logged
          // corner variance=0.00 and was wrongly treated as blocked). drawImage's scaling
          // interpolates from the entire source frame, so a face/person occupying a meaningful
          // portion of a centered exam frame still shows up as real variance in the thumbnail
          // even when isolated patches are locally flat, while a solid-color placeholder with
          // one small icon stays low-variance across the whole thumbnail.
          const UNIFORM_FRAME_VARIANCE_THRESHOLD = 1.5;
          if (!varianceSampleCanvasRef.current) {
            varianceSampleCanvasRef.current = document.createElement("canvas");
            varianceSampleCanvasRef.current.width = 44;
            varianceSampleCanvasRef.current.height = 36;
          }
          const sampleCanvas = varianceSampleCanvasRef.current;
          const sampleCtx = sampleCanvas.getContext("2d");
          let hasContent = false;
          const maxRetries = camvasStreamFailedRef.current ? 0 : BLACK_FRAME_MAX_RETRIES;
          for (let attempt = 0; attempt < maxRetries; attempt++) {
            if (!drawFrame()) {
              await new Promise((resolve) => setTimeout(resolve, BLACK_FRAME_RETRY_INTERVAL_MS));
              continue;
            }
            sampleCtx.drawImage(imageSrc, 0, 0, sampleCanvas.width, sampleCanvas.height);
            const sample = sampleCtx.getImageData(0, 0, sampleCanvas.width, sampleCanvas.height).data;
            let sumLuma = 0, sumLumaSq = 0, sampleCount = 0;
            hasContent = false;
            for (let i = 0; i < sample.length; i += 4) {
              const luma = (sample[i] + sample[i + 1] + sample[i + 2]) / 3;
              sumLuma += luma;
              sumLumaSq += luma * luma;
              sampleCount++;
              if (sample[i] > 10 || sample[i + 1] > 10 || sample[i + 2] > 10) {
                hasContent = true;
              }
            }
            if (hasContent) {
              const meanLuma = sumLuma / sampleCount;
              const variance = sumLumaSq / sampleCount - meanLuma * meanLuma;
              isCameraBlockedPlaceholder = variance < UNIFORM_FRAME_VARIANCE_THRESHOLD;
              console.log(`Successfully captured non-black frame on attempt ${attempt + 1} for proctoring (frame variance=${variance.toFixed(2)}${isCameraBlockedPlaceholder ? ", treating as camera-blocked placeholder" : ""})`);
              break;
            }
            await new Promise((resolve) => setTimeout(resolve, BLACK_FRAME_RETRY_INTERVAL_MS));
          }

          if (!hasContent) {
            // The stream itself is dead, not just momentarily slow - retrying against the same
            // stream again next cycle would never recover it. Re-acquire the camera now so
            // future captures get a real chance, instead of staying black for the rest of the exam.
            console.warn(`Camera feed still black after ${BLACK_FRAME_MAX_RETRIES} retries for proctoring, restarting camera stream and saving last available frame`);
            restartCamvasStream();
          }
        }
      }

      img2 = new Image();
      // 0.65 quality balances bandwidth savings with enough detail for accurate face matching
      img2.src = imageSrc.toDataURL("image/jpeg", 0.65);
      // Stored photo: a smaller copy so photo storage stays near its old size; re-encoded at
      // 0.8 by reduceImageSize before saving.
      image = drawScaledCopy(imageSrc, storedCanvasRef.current, STORED_FRAME_LONG_SIDE).toDataURL("image/jpeg");

      grabConfirmationFrame = () => {
        drawFrame();
        const frame = new Image();
        frame.src = imageSrc.toDataURL("image/jpeg", 0.65);
        return frame;
      };
    } catch (captureErr) {
      console.error("Error capturing proctoring frame:", captureErr);
      captureInProgressRef.current = false;
      markPhotoUnsent();
      return;
    }
    captureInProgressRef.current = false;

    // The timed photo is saved whatever the checks below find.
    if (!checkOnly) saveTimedPhoto(image);

    // Checks (warnings only): one at a time, and not while a warning is on screen.
    if (apiInFlightRef.current || !intervalOnRef.current) {
      if (apiInFlightRef.current && intervalOnRef.current) checkPendingRef.current = true;
      return;
    }
    apiInFlightRef.current = true;

    // Use backend API for face detection
    let result, error, faceCount, expression1, expression2, objectsDetected, objectsCount;
    let faceUnverified = false;
    let faceCoveredNow = false;
    let lookingAway = false;
    if (isCameraBlockedPlaceholder) {
      // Skip the AI entirely - it's unreliable on this synthetic placeholder (see comment
      // above isCameraBlockedPlaceholder) and this frame is already known to have no real face.
      result = false;
      error = "N";
      faceCount = 0;
      expression1 = "Unknown";
      expression2 = "Unknown";
      objectsDetected = [];
      objectsCount = 0;
      apiInFlightRef.current = false;
      lastPhotoAnsweredAtRef.current = Date.now();
    } else {
      let confirmed = true;
      try {
        const burstId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        const firstCheck = await detectFaces2(img2, { burstId, burstIndex: 0 });
        if (firstCheck.unreachable) markPhotoUnsent("network");
        // The server answered but the face check failed (5xx) - nothing gets stored for this
        // photo either.
        else if (firstCheck.error === "S") markPhotoUnsent("server");
        else markPhotoAnswered();
        ({ result, error, faceCount, expression1, expression2, objectsDetected, objectsCount } = firstCheck);
        lookingAway = firstCheck.lookingAway === true;
        recordCoveredFace(firstCheck.faceCovered, image, firstCheck.faceHiddenReason);
        console.log("result", result)
        console.log("error", error)

        // Confirmation burst: a single frame is not enough evidence for a violation (a blink,
        // a glance, motion blur, one spurious detection). When this frame looks like one, take
        // CONFIRM_FRAMES more frames ~CONFIRM_INTERVAL_MS apart and only raise the warning (and
        // count it) if at least 2 frames show the same kind of violation.
        const kind = violationKind({ result, error, faceCount, lookingAway });
        faceUnverified = !kind && firstCheck.faceUnverified === true;
        faceCoveredNow = !kind && firstCheck.faceCovered === true && firstCheck.faceHiddenReason !== "turned_away";
        if (kind && grabConfirmationFrame) {
          // One more frame, and both must agree (two more with 2 of 3 took longer for the same answer).
          const CONFIRM_FRAMES = 1;
          const CONFIRM_INTERVAL_MS = kind === "lookingAway" ? LOOKING_AWAY_CONFIRM_MS : 700;
          const checks = [];
          for (let i = 0; i < CONFIRM_FRAMES; i++) {
            await new Promise((r) => setTimeout(r, CONFIRM_INTERVAL_MS));
            checks.push(detectFaces2(grabConfirmationFrame(), { recordSentiment: false, burstId, burstIndex: i + 1 }));
          }
          const confirmations = await Promise.all(checks);
          const agreeing = 1 + confirmations.filter((c) => violationKind(c) === kind).length;
          confirmed = agreeing >= 2;
          console.log(`Proctoring ${kind}: ${agreeing}/${CONFIRM_FRAMES + 1} frames agree - ${confirmed ? "confirmed" : "not confirmed, ignored"}`);
        }
      } finally {
        apiInFlightRef.current = false;
      }
      if (!confirmed) {
        // Not a real violation - no warning, no count; the next scheduled capture continues.
        return;
      }
    }

    // Set state for objects detected
    setObjectsDetected(objectsDetected);
    setObjectsCount(objectsCount);

    // Check camera is identifying image or not
    if (error === "R") {
      // Unusable reference photo (detectFaces2's "Invalid primary image format") - a system-side
      // data problem, not the candidate. It used to show the "face not found" popup and pause
      // proctoring, again on every cycle. Now: reload the server's copy of the original
      // reference and carry on; if that is unusable too, just retry next cycle (like "S").
      // Never counts against the face-not-found budget, never a popup.
      handleUnusableReference();
      return;
    }
    if (error === "S") {
      // System failure (network/timeout, or the face-match microservice's own 500) - the
      // model never actually returned a verdict on this frame, so unlike a genuine
      // face-not-found result this must never count against the candidate's budget, get
      // logged as a violation image, or alarm them with a modal. Just let the next
      // scheduled capture interval retry.
      return;
    }
    if (FACE_COVERED_WARN_AFTER !== null) {
      faceCoveredStreakRef.current = faceCoveredNow ? faceCoveredStreakRef.current + 1 : 0;
      if (faceCoveredStreakRef.current >= FACE_COVERED_WARN_AFTER) {
        console.log(`Face covered or not visible on ${faceCoveredStreakRef.current} photo checks in a row - treated as face not visible`);
        faceCoveredStreakRef.current = 0;
        faceCount = 0;
      }
    }
    if (FACE_UNVERIFIED_CHECK_ON && MonitoringData.result.photo_matching === true) {
      faceUnverifiedStreakRef.current = faceUnverified ? faceUnverifiedStreakRef.current + 1 : 0;
      if (faceUnverifiedStreakRef.current >= FACE_UNVERIFIED_WARN_AFTER) {
        console.log(`Face not clear enough to verify on ${faceUnverifiedStreakRef.current} photo checks in a row - treated as face not visible`);
        faceUnverifiedStreakRef.current = 0;
        faceCount = 0;
      }
    }
    if (faceCount === 0) {
      noFaceCountRef.current += 1;
      // if (noFaceCountRef.current < CONSECUTIVE_THRESHOLD) return;
      noFaceCountRef.current = 0;
      // Real, persisted-for-this-session count backing the abort threshold
      // (examDetail[0].imageproctoringcount, checked in Test.jsx) - unlike
      // noFaceCountRef above, this one is never reset mid-exam. Counted for every exam so
      // reports show it; only Photo Action = Stop aborts on it (Test.jsx).
      // Mirrored onto examDetail[0] (not just React state) so it rides along on the very
      // next saveToMongoFunction call below and survives a resume/reload - Test.jsx
      // rehydrates faceNotFoundCount's initial state from this same field.
      const nextFaceNotFoundCount = faceNotFoundCount + 1;
      setFaceNotFoundCount(nextFaceNotFoundCount);
      examDetail[0].faceNotFoundCount = nextFaceNotFoundCount;
      saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData, null, setisMongoUpdated);
      setIntervalOn(false);
      setNoFaceAlertModal(true);

      let image1 = await reduceImageSize(image);
      axios
        .post("/test/saveErrorImage", {
          headers: { "Access-Control-Allow-Origin": "*" },
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: 0,
          error: "N",
          imagePath: image1,
          expression1: "Unknown",
          expression2: "Unknown",
          phototag: "faceNotDetected",
        })
        .then((resp) => {
          resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
        })
        .catch((_err) => {
          setHidden(true);
        });
      return;
    }
    // Reset no-face counter when face is detected
    noFaceCountRef.current = 0;

    // Check multiple faces criteria (only if multiple_faces flag is enabled)
    // A phone in the same photo is warned as the phone (violationKind's order).
    if (MonitoringData.result.multiple_faces === true && faceCount >= 2 && !(error === "O" && MonitoringData.result.object_detection === true)) {
      multipleFaceCountRef.current += 1;
      // if (multipleFaceCountRef.current < CONSECUTIVE_THRESHOLD) return;
      multipleFaceCountRef.current = 0;
      // Persisted warning count for the Proctoring Warnings limit (abort decided in Test.jsx).
      // examDetail[0] is the source of truth so a stale closure can't lose an increment, and
      // it is set before saveToMongoFunction below so the save carries it.
      const nextMultipleFaceCount = (examDetail[0].multipleFaceCount || 0) + 1;
      examDetail[0].multipleFaceCount = nextMultipleFaceCount;
      setMultipleFaceCount(nextMultipleFaceCount);
      saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData, null, setisMongoUpdated);
      setIntervalOn(false);
      setMultipleFaceAlertModal(true);

      let image1 = await reduceImageSize(image);
      axios
        .post("/test/saveErrorImage", {
          headers: { "Access-Control-Allow-Origin": "*" },
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: faceCount,
          error: "M",
          imagePath: image1,
          expression1: expression1 || "Unknown",
          expression2: expression2 || "Unknown",
          phototag: "multipleFaces",
        })
        .then((resp) => {
          resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
        })
        .catch((_err) => {
          setHidden(true);
        });
      return;
    }

    // Reset multiple face counter on clean frame
    if (faceCount < 2) multipleFaceCountRef.current = 0;

    // Handle multiple faces when multiple_faces flag is disabled
    if (MonitoringData.result.multiple_faces === false && faceCount >= 2) {
      // Already saved as the timed photo (saveTimedPhoto).
      return;
    }

    // Reset object counter on clean frame, check object detection criteria
    if (error !== "O") objectDetectedCountRef.current = 0;

    if (MonitoringData.result.object_detection === true && error === "O") {
      objectDetectedCountRef.current += 1;
      // if (objectDetectedCountRef.current < CONSECUTIVE_THRESHOLD) return;
      objectDetectedCountRef.current = 0;
      // Persisted warning count for the Proctoring Warnings limit (abort decided in Test.jsx).
      const nextObjectDetectedCount = (examDetail[0].objectDetectedCount || 0) + 1;
      examDetail[0].objectDetectedCount = nextObjectDetectedCount;
      setObjectDetectedCount(nextObjectDetectedCount);
      saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData, null, setisMongoUpdated);
      setIntervalOn(false);
      setObjectDetectedAlertModal(true);

      let image1 = await reduceImageSize(image);
      axios
        .post("/test/saveErrorImage", {
          headers: { "Access-Control-Allow-Origin": "*" },
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: faceCount,
          error: "O",
          imagePath: image1,
          expression1: expression1 || "Unknown",
          expression2: expression2 || "Unknown",
          phototag: "objectDetected",
          objectsdetected: objectsDetected,
          objectscount: objectsCount,
        })
        .then((resp) => {
          resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
        })
        .catch((_err) => {
          setHidden(true);
        });
      return;
    }

    // Handle object detection when object_detection flag is disabled
    if (MonitoringData.result.object_detection === false && error === "O") {
      // Already saved as the timed photo (saveTimedPhoto).
      return;
    }

    // Looking Away switch: a confirmed look away is a warning, counted against the Proctoring
    // Warnings limit like the other photo checks (abort decided in Test.jsx). Within
    // LOOKING_AWAY_GAP_MS of the last one it isn't shown or counted.
    // Another person's face is warned as a mismatch, not as looking away (violationKind's order).
    if (MonitoringData.result.looking_away === true && lookingAway && !(MonitoringData.result.photo_matching === true && result === false)) {
      if (Date.now() - lastLookingAwayWarningAtRef.current < LOOKING_AWAY_GAP_MS) return;
      lastLookingAwayWarningAtRef.current = Date.now();
      const nextLookingAwayCount = (examDetail[0].lookingAwayCount || 0) + 1;
      examDetail[0].lookingAwayCount = nextLookingAwayCount;
      if (typeof setLookingAwayCount === "function") setLookingAwayCount(nextLookingAwayCount);
      saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData, null, setisMongoUpdated);
      setIntervalOn(false);
      setLookingAwayAlertModal(true);

      let image1 = await reduceImageSize(image);
      axios
        .post("/test/saveErrorImage", {
          headers: { "Access-Control-Allow-Origin": "*" },
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: faceCount,
          error: "L",
          imagePath: image1,
          expression1: expression1 || "Unknown",
          expression2: expression2 || "Unknown",
          phototag: "lookingAway",
        })
        .then((resp) => {
          resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
        })
        .catch((_err) => {
          setHidden(true);
        });
      return;
    }

    // Check photo_matching condition
    if (MonitoringData.result.photo_matching === false) {
      // Check result value
      if (result === false) {
        let image1 = await reduceImageSize(image);
        let photoTag;
        if (error === "N") photoTag = "faceNotDetected";
        else if (error === "M") photoTag = "multipleFaces";
        else if (error === "O") photoTag = "objectDetected";
        else photoTag = "other";

        axios
          .post("/test/saveErrorImage", {
            headers: { "Access-Control-Allow-Origin": "*" },
            userid: examDetail[0].userid,
            userexamid: examDetail[0].id,
            facecount: faceCount,
            error: error,
            imagePath: image1,
            expression1: expression1,
            expression2: expression2,
            phototag: photoTag,
            ...(error === "O" && { objectsdetected: objectsDetected, objectscount: objectsCount }),
          })
          .then((resp) => {
            resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
          })
          .catch((_err) => {
            setHidden(true);
          });
        return;
      }

      if (result === true) {
        // Already saved as the timed photo (saveTimedPhoto).
        return;
      }
    }

    if (MonitoringData.result.photo_matching === true) {
      if (result === false) {
        let photoTag;
        if (error === "N") photoTag = "faceNotDetected";
        else if (error === "M") photoTag = "multipleFaces";
        else if (error === "O") photoTag = "objectDetected";
        else photoTag = "faceMismatch";

        if (MonitoringData.result.photo_action === "S" && false) {
          if (photoMismatchCount === examDetail[0].imageproctoringcount) {
            setProctoringEnd(true);
          }
          setPhotoMismatchCount((photoMismatchCount) => (photoMismatchCount += 1));
          setIsPhotoMatchingInProgress(true)
          setIntervalOn(false);

          if (error === "O") {
            setObjectDetectedAlertModal(true);
          } else {
            setImageAlertShowModal(true);
          }

          let image1 = await reduceImageSize(image);
          axios
            .post("/test/saveErrorImage", {
              headers: { "Access-Control-Allow-Origin": "*" },
              userid: examDetail[0].userid,
              userexamid: examDetail[0].id,
              facecount: faceCount,
              error: error,
              imagePath: image1,
              expression1: expression1,
              expression2: expression2,
              phototag: photoTag,
              ...(error === "O" && { objectsdetected: objectsDetected, objectscount: objectsCount }),
            })
            .then((resp) => {
              resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
            })
            .catch((_err) => {
              setHidden(true);
            });
          return;
        }

        noMatchCountRef.current += 1;
        // if (noMatchCountRef.current < CONSECUTIVE_THRESHOLD) return;
        noMatchCountRef.current = 0;
        // Identity mismatches are counted (saved with the test progress and reported) but do
        // not abort yet: single-frame false mismatches are still common until the frame-quality
        // and confirmation checks land. Only true mismatches count, not the "N"/"M"/"O" results
        // that also fail photo matching.
        if (photoTag === "faceMismatch") {
          const nextPhotoMismatchCount = (examDetail[0].photoMismatchCount || 0) + 1;
          examDetail[0].photoMismatchCount = nextPhotoMismatchCount;
          setPhotoMismatchCount(nextPhotoMismatchCount);
        }
        setIntervalOn(false);

        if (error === "O") {
          setObjectDetectedAlertModal(true);
        } else {
          setNoMatchAlertModal(true);
        }

        let image1 = await reduceImageSize(image);
        axios
          .post("/test/saveErrorImage", {
            headers: { "Access-Control-Allow-Origin": "*" },
            userid: examDetail[0].userid,
            userexamid: examDetail[0].id,
            facecount: faceCount,
            error: error,
            imagePath: image1,
            expression1: expression1,
            expression2: expression2,
            phototag: photoTag,
            ...(error === "O" && { objectsdetected: objectsDetected, objectscount: objectsCount }),
          })
          .then((resp) => {
            resp.data.msg === "SUCCESS" ? setHidden(false) : setHidden(true);
          })
          .catch((_err) => {
            setHidden(true);
          });
        return;
      }

      if (result === true) {
        setIsPhotoMatchingInProgress(false)
        noMatchCountRef.current = 0;
        // Already saved as the timed photo (saveTimedPhoto).
        return;
      }
    }
  };

  // const handleAudioConfirm = async () => {
  //   setAudioAlertShowModal(false);
  //   setIntervalOn(true);
  //   setcheck(true);

  //   if (AudioCount === 4) {
  //     window.onbeforeunload = function () {
  //       return null;
  //     };
  //     window.location.reload("/dashboard");
  //     return;
  //   }
  // };

  const handleConfirm = async () => {
    setImageAlertShowModal(false);
    setNoFaceAlertModal(false);

    // Past the limit, Test.jsx has already submitted the test as Proctoring Aborted (113) -
    // don't restart capture. This used to reload the page instead (reload() ignores its
    // "/dashboard" argument), which never ended the test and showed a "Reload site?" prompt.
    if (MonitoringData.result.photo_action === "S" && isFaceNotFoundBudgetExceeded(examDetail, faceNotFoundCount)) {
      return;
    }

    await saveImage();
    setcheck(true);
    setIntervalOn(true);
  };

  const handleResumeTest = async () => {
    setIntervalOn(true);
    setNoFaceAlertModal(false);
    setMultipleFaceAlertModal(false);
    setObjectDetectedAlertModal(false);
    setLookingAwayAlertModal(false);
    // OK always returns the candidate to the test. This used to call
    // window.location.reload("/dashboard") when photo_action was "S", but reload() ignores
    // its argument, so it only reloaded the test page (never stopped the test) and triggered
    // the browser's "Reload site?" prompt from reloadFunction.js's beforeunload listener.
    // Stop-on-violation is handled by handleConfirm's violation-limit check.
  };

  const handleNoMatchOk = async () => {
    setNoMatchAlertModal(false);
    setIntervalOn(true);
  };

  useEffect(() => {
    const captureImage = async () => {
      // Every tick takes and saves a photo, also while a warning is on screen (only the checks
      // wait for OK - saveImage). Keep capturing regardless of how many photo mismatches there
      // have been: mismatches are counted but don't abort.
      if (examDetail[0].monitoringflag) {
        saveImage();
        setIntervalCount((IntevalCount) => IntevalCount += 1);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    captureIntervalId = setTimeout(captureImage, captureImageInterval);
    return () => {
      if (captureIntervalId) {
        clearTimeout(captureIntervalId);
      }
    };
  }, [intervalCount, IntervalOn]);

  // Photo at submit (exam-end gap): a candidate could hide or turn off the camera in the last
  // minutes and submit before the next photo was due. When the candidate submits (Test.jsx), one
  // last photo is checked and saved - a violation as a warning photo for the report (no popup,
  // the test is ending), otherwise as a normal photo. Waits at most
  // REACT_APP_FINAL_PHOTO_TIMEOUT_SECONDS (env; missing = off); if the photo can't reach the
  // server in time the test still submits. Returns what happened, stored with the submitted test
  // (examDetail[0].finalPhoto): ok | no_face | multiple_faces | object | not_sent, or null when off.
  const FINAL_PHOTO_TIMEOUT_MS = Number(process.env.REACT_APP_FINAL_PHOTO_TIMEOUT_SECONDS) > 0 ? Number(process.env.REACT_APP_FINAL_PHOTO_TIMEOUT_SECONDS) * 1000 : null;
  const finalPhotoCheck = async () => {
    if (FINAL_PHOTO_TIMEOUT_MS === null) return null;
    const deadline = Date.now() + FINAL_PHOTO_TIMEOUT_MS;
    const withinDeadline = (promise) =>
      Promise.race([promise, new Promise((resolve) => setTimeout(() => resolve({ timedOut: true }), Math.max(0, deadline - Date.now())))]);
    try {
      const recordingVideo = isRecording && recordingVideoRef && recordingVideoRef.current;
      const sourceVideo = recordingVideo && recordingVideo.readyState >= 2 ? recordingVideo : camvas.current && camvas.current.video;
      const analysis = document.createElement("canvas");
      if (!drawVideoFrame(sourceVideo, analysis, ANALYSIS_FRAME_LONG_SIDE)) return "not_sent";
      const frame = new Image();
      frame.src = analysis.toDataURL("image/jpeg", 0.65);
      const stored = drawScaledCopy(analysis, document.createElement("canvas"), STORED_FRAME_LONG_SIDE).toDataURL("image/jpeg");

      const check = await withinDeadline(detectFaces2(frame, { recordSentiment: false, burstId: `final-${Date.now().toString(36)}`, burstIndex: 0 }));
      if (check.timedOut || check.error === "S" || check.error === "R") return "not_sent";

      let outcome = "ok";
      let saved;
      const photo = await reduceImageSize(stored);
      const common = { headers: { "Access-Control-Allow-Origin": "*" }, userid: examDetail[0].userid, userexamid: examDetail[0].id, imagePath: photo, expression1: check.expression1 || "Unknown", expression2: check.expression2 || "Unknown" };
      if (check.faceCount === 0) {
        outcome = "no_face";
        saved = axios.post("/test/saveErrorImage", { ...common, facecount: 0, error: "N", phototag: "faceNotDetected" });
      } else if (check.faceCount >= 2 && MonitoringData.result.multiple_faces === true) {
        outcome = "multiple_faces";
        saved = axios.post("/test/saveErrorImage", { ...common, facecount: check.faceCount, error: "M", phototag: "multipleFaces" });
      } else if (MonitoringData.result.object_detection === true && check.objectsCount > 0) {
        outcome = "object";
        saved = axios.post("/test/saveErrorImage", { ...common, facecount: check.faceCount, error: "O", phototag: "objectDetected", objectsdetected: check.objectsDetected, objectscount: check.objectsCount });
      } else {
        saved = axios.post("/test/saveImage", { ...common, instanceid: examDetail[0].instanceid, phototag: "regular" });
      }
      await withinDeadline(saved.catch(() => null));
      return outcome;
    } catch (e) {
      console.error("Final photo at submit failed:", e);
      return "not_sent";
    }
  };
  if (finalPhotoRef) finalPhotoRef.current = finalPhotoCheck;

  // Missing photos (see PHOTO_UNSENT_BLOCK_AFTER). Time a popup holds the photos (IntervalOn
  // false) is not a gap, so the clock restarts when photos resume.
  const saveImageRef = useRef(null);
  saveImageRef.current = saveImage;
  intervalOnRef.current = IntervalOn;
  useEffect(() => {
    if (IntervalOn) lastPhotoAnsweredAtRef.current = Date.now();
  }, [IntervalOn]);
  useEffect(() => {
    if (!PHOTO_UNSENT_CHECK_ON || !examDetail[0].monitoringflag) return undefined;
    const watchdog = setInterval(() => {
      // The photo loop itself stuck: no answer for PHOTO_UNSENT_BLOCK_AFTER photo intervals
      // (plus the 15 s request timeout).
      if (IntervalOn && !cameraFailedModalOpen && Date.now() - lastPhotoAnsweredAtRef.current > captureImageInterval * PHOTO_UNSENT_BLOCK_AFTER + 15000) {
        setPhotoNotSentCause("network");
        setPhotoNotSent(true);
      }
    }, 5000);
    return () => clearInterval(watchdog);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IntervalOn, cameraFailedModalOpen]);
  useEffect(() => {
    if (!photoNotSent) return undefined;
    const retry = setInterval(() => saveImageRef.current && saveImageRef.current(), PHOTO_UNSENT_RETRY_MS);
    return () => clearInterval(retry);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photoNotSent]);

  // Timer pause for a server-side block (see PHOTO_SERVER_PAUSE_MAX_BLOCK_MS).
  const serverPausedSecondsUsed = () => Number(examDetail[0].photoServerPausedSeconds) || 0;
  const endServerPause = (outcome) => {
    if (serverPauseStartedAtRef.current === null) return;
    const blockMs = Math.min(Date.now() - serverPauseStartedAtRef.current, PHOTO_SERVER_PAUSE_MAX_BLOCK_MS);
    serverPauseStartedAtRef.current = null;
    const usedSeconds = Math.min(serverPausedSecondsUsed() + Math.round(blockMs / 1000), PHOTO_SERVER_PAUSE_MAX_TOTAL_MS / 1000);
    const pausedSeconds = usedSeconds - serverPausedSecondsUsed();
    examDetail[0].photoServerPausedSeconds = usedSeconds;
    if (setIsPhotoServerPaused) setIsPhotoServerPaused(false);
    // So reviewers can see the test was paused, and for how long (failure ledger).
    axios
      .post("/test/proctoring/photo-paused", {
        userid: examDetail[0].userid,
        userexamid: examDetail[0].id,
        pausedSeconds,
        totalPausedSeconds: usedSeconds,
        outcome,
      })
      .catch(() => { });
  };
  const serverBlocked = photoNotSent && photoNotSentCause === "server";
  useEffect(() => {
    if (!serverBlocked || !PHOTO_SERVER_PAUSE_ON) {
      endServerPause("recovered");
      setServerPauseState("none");
      return undefined;
    }
    if (serverPausedSecondsUsed() * 1000 >= PHOTO_SERVER_PAUSE_MAX_TOTAL_MS) {
      setServerPauseState("running");
      return undefined;
    }
    serverPauseStartedAtRef.current = Date.now();
    if (setIsPhotoServerPaused) setIsPhotoServerPaused(true);
    setServerPauseState("paused");
    const tick = setInterval(() => {
      const blockMs = Date.now() - serverPauseStartedAtRef.current;
      if (serverPausedSecondsUsed() * 1000 + blockMs >= PHOTO_SERVER_PAUSE_MAX_TOTAL_MS) {
        clearInterval(tick);
        endServerPause("allowance_used");
        setServerPauseState("running");
      } else if (blockMs >= PHOTO_SERVER_PAUSE_MAX_BLOCK_MS) {
        // The timer stays paused while the candidate reads this; only the block limit is counted.
        clearInterval(tick);
        setServerPauseState("expired");
      }
    }, 1000);
    return () => clearInterval(tick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverBlocked]);

  // Not an exam abort - the test stays resumable with the remaining time saved here.
  const handleServerPauseGoToDashboard = async () => {
    endServerPause("sent_to_dashboard");
    try {
      await saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData, null, setisMongoUpdated);
    } catch (e) {
      // Our server may still be failing - the last saved time is used on resume.
    }
    window.onbeforeunload = function () {
      return null;
    };
    window.location.replace("/v2/user/dashboard");
  };

  // Audio interval logic removed - BackgroundAudioRecorder handles continuous recording

  // Bounded so a stream that never opens (permission denied, unsupported device) doesn't retry
  // forever - genuine failures fall through to the per-capture-cycle recovery in saveImage().
  const CAMVAS_START_RETRY_MAX = 2;
  // getUserMedia can neither resolve nor reject on some devices (a stuck permission prompt, an
  // OS camera-service deadlock). Seen live: a candidate whose camera never came up across 3
  // logins over 16 hours left no trace - no retry, no camera-failed beacon, no popup - because
  // all of that runs only on a rejection. A camera that hasn't opened by this time counts as a
  // failed attempt and goes through the same retry / camera-failed handling.
  const CAMERA_OPEN_TIMEOUT_MS = 15000;

  // getUserMedia with a time limit. A stream that arrives after the limit is released at once,
  // so a late camera isn't left running (and held) after the attempt already moved on.
  const openProctoringCamera = () =>
    new Promise((resolve, reject) => {
      let settled = false;
      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        const error = new Error(`Camera did not open within ${CAMERA_OPEN_TIMEOUT_MS / 1000} s`);
        error.name = "CameraOpenTimeout";
        reject(error);
      }, CAMERA_OPEN_TIMEOUT_MS);
      navigator.mediaDevices.getUserMedia(PROCTORING_CAMERA_CONSTRAINTS).then(
        (stream) => {
          if (settled) {
            stream.getTracks().forEach((track) => track.stop());
            return;
          }
          settled = true;
          clearTimeout(timer);
          resolve(stream);
        },
        (err) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  const CAMVAS_START_RETRY_DELAY_MS = 1500;

  // Extracted so a dead camera stream can be re-acquired mid-exam (see restartCamvasStream)
  // instead of only being set up once at mount with no way to recover.
  const startCamvas = (attempt = 0) => {
    // No per-frame callback: frames are drawn from instance.video only when a photo is taken
    // (see saveImage). The old callback repainted a canvas and computed a grayscale image for
    // an unused face detector about 60 times a second.
    const instance = new Camvas(null);
    camvas.current = instance;
    camvasStreamFailedRef.current = false;
    // Opened and played here rather than by Camvas.play() so the stream can be shared with
    // VideoInterview (utils/sharedCamera.js). Camvas.play() also never settles its promise when
    // it opens the camera itself, or when video.play() rejects, so the recovery handling below
    // never ran.
    openProctoringCamera()
      .then((stream) => {
        if (camvas.current !== instance) {
          // Restarted or unmounted while the camera was opening - don't leave it running.
          stream.getTracks().forEach((track) => track.stop());
          return null;
        }
        instance.video.muted = true;
        instance.video.srcObject = stream;
        if (sharedCameraStreamRef) sharedCameraStreamRef.current = stream;
        return instance.video.play().then(() => {
          if (camvas.current !== instance) return false;
          return true;
        });
      })
      .then((started) => {
        if (!started) return;
        // Recovered (either the initial attempt succeeded, or a Retry Camera click did) -
        // this device IS capable of proctoring after all, so give it a fresh failure budget
        // if the stream ever dies again later in the exam, and close the modal.
        cameraFailureCycleCountRef.current = 0;
        setCameraFailureTerminal(false);
        setCameraFailedModalOpen(false);
      })
      .catch((err) => {
        if (camvas.current !== instance) return;
        // The camera may have opened before play() failed - release it before any retry.
        if (instance.video.srcObject) {
          releaseSharedCameraStream();
          instance.stop();
        }
        // getUserMedia can reject transiently on low-end/single-camera-pipeline devices if
        // another consumer (the pre-exam permission-priming check, the reference-photo webcam)
        // hasn't fully released the camera yet. A short bounded retry lets that contention
        // clear before giving up - previously this rejection was unhandled entirely, so the
        // canvas silently stayed black for the rest of the exam with no signal anywhere.
        if (attempt < CAMVAS_START_RETRY_MAX) {
          console.warn(`Proctoring camera failed to start (attempt ${attempt + 1}/${CAMVAS_START_RETRY_MAX + 1}), retrying:`, err && err.name, err && err.message);
          camvasRetryTimeoutRef.current = setTimeout(() => startCamvas(attempt + 1), CAMVAS_START_RETRY_DELAY_MS);
        } else {
          camvasStreamFailedRef.current = true;
          cameraFailureCycleCountRef.current += 1;
          const isTerminal = cameraFailureCycleCountRef.current >= MAX_CAMERA_FAILURE_CYCLES;
          console.error(
            `Proctoring camera failed to start after retries (cycle ${cameraFailureCycleCountRef.current}/${MAX_CAMERA_FAILURE_CYCLES}):`,
            err && err.name, err && err.message
          );
          // Fire-and-forget beacon so this failure shows up in the ops
          // failure ledger (stage "camera_never_started") instead of being
          // completely invisible server-side - previously the only trace was
          // a browser console.error nobody could see after the fact. Forced
          // to needs_manual_review once terminal, since that's the point the
          // candidate actually got sent back to the dashboard over this.
          axios
            .post("/test/proctoring/camera-failed", {
              userid: examDetail[0].userid,
              userexamid: examDetail[0].id,
              errorName: (err && err.name) || "Unknown",
              errorMessage: (err && err.message) || "Camera failed to start after retries",
              userAgent: navigator.userAgent,
              attempts: attempt + 1,
              cycle: cameraFailureCycleCountRef.current,
              terminal: isTerminal,
            })
            .catch(() => { });
          // Hard block - no dismiss, no "continue anyway". The candidate cannot proceed with
          // the exam until the camera works, or (once terminal) is sent back to the dashboard.
          setCameraFailureTerminal(isTerminal);
          setCameraFailedModalOpen(true);
        }
      });
  };

  const handleRetryCamera = () => {
    setCameraFailedModalOpen(false);
    restartCamvasStream();
  };

  // Not an exam abort/violation - the exam's status is left untouched so the candidate can
  // resume the same test on a working device. Matches the reload("/dashboard") pattern used
  // everywhere else in this codebase for "leave the exam and go back to the dashboard".
  const handleCameraIncompatibleGoToDashboard = () => {
    window.onbeforeunload = function () {
      return null;
    };
    window.location.reload("/dashboard");
  };

  // Camvas's constructor appends a hidden <div><video> pair straight to document.body
  // (see @msvargas97/pico.js) and its own stop() only releases the media stream, never
  // removes those nodes. Every restart otherwise leaks another orphaned pair into the page
  // for the rest of the session - real accumulation on a long exam with a flaky camera.
  const cleanupCamvasDom = (instance) => {
    try {
      const videoEl = instance && instance.video;
      if (videoEl && videoEl.parentNode) {
        videoEl.parentNode.remove();
      }
    } catch (e) {
      // ignore - nothing more we can do if the node is already gone
    }
  };

  // Clears the stream VideoInterview would record from. Proctoring's own track is stopped by
  // camvas.stop(); a recording already running on a clone of it keeps going until it stops.
  const releaseSharedCameraStream = () => {
    if (sharedCameraStreamRef) sharedCameraStreamRef.current = null;
  };

  // Forces the camera to be re-acquired when the feed has been confirmed dead (still black
  // after 15 retries). Polling the same stream again would never recover it - browsers/OS can
  // silently starve a live camera track (tab backgrounding, driver hiccups, a second consumer
  // briefly holding the device) without ever changing its readyState, so the only reliable fix
  // is to stop and re-request the stream rather than keep reading from the broken one.
  const restartCamvasStream = () => {
    // Drop any in-flight startCamvas retry chain so it can't race with this fresh attempt.
    if (camvasRetryTimeoutRef.current) {
      clearTimeout(camvasRetryTimeoutRef.current);
      camvasRetryTimeoutRef.current = null;
    }
    releaseSharedCameraStream();
    try {
      if (camvas.current && typeof camvas.current.stop === "function") {
        camvas.current.stop();
      }
    } catch (e) {
      // ignore - proceed to re-acquire regardless
    }
    cleanupCamvasDom(camvas.current);
    startCamvas();
  };

  useEffect(() => {
    startCamvas();
    return () => {
      // Without this, a remount (for any reason) leaves the old Camvas instance's
      // getUserMedia stream and requestAnimationFrame loop running forever, while a new
      // instance requests a SECOND stream from the same camera - a self-inflicted version
      // of the exact camera contention that produces black frames.
      releaseSharedCameraStream();
      if (camvas.current && typeof camvas.current.stop === "function") {
        camvas.current.stop();
      }
      cleanupCamvasDom(camvas.current);
      // Cancel a pending startCamvas retry so it can't re-acquire the camera after unmount.
      if (camvasRetryTimeoutRef.current) {
        clearTimeout(camvasRetryTimeoutRef.current);
        camvasRetryTimeoutRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _onPlay = () => {
    camvas.current.play();
    if (examDetail[0].monitoringflag) {
      setTimeout(saveImage(), 30000);
    }
  };

  const _onPause = () => {
    camvas.current.pause();
  };

  const _onStop = () => {
    camvas.current.stop();
    setSnapShow(false);
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <center>
          <label>
            <input type="checkbox" ref={withPupilsRef} defaultChecked />
            with pupils
          </label>
          <select name="shape" ref={shapeRef}>
            <option value="circle">Circle</option>
            <option value="shape">Square</option>
          </select>
        </center>
      </div>
      {/* {MonitoringData.result.speaker_dialect === true && (
        <BackgroundAudioRecorder
          examDetail={examDetail}
          questionNo={questionNo}
          MonitoringData={MonitoringData}
          AudioCount={AudioCount}
          setAudioCount={setAudioCount}
          setAudioAlertShowModal={setAudioAlertShowModal}
          setProctoringEnd={setProctoringEnd}
          alertVisible={AudioAlertShowModal}
        />
      )} */}
      <div>
        <ImageAlertModal onConfirm={handleConfirm} open={ImageAlertShowModal} examDetail={examDetail} photoMismatchCount={photoMismatchCount} />
        {/* AudioAlertModal is driven by BackgroundAudioRecorder's own independent audio-upload
            interval, decoupled from the face-detection loop below - it can fire while a
            face/object/match modal is already open. Its backdrop forces zIndex 99999, well
            above every other modal's default MUI stacking, so if both are open it silently
            blankets the already-open modal underneath, leaving that modal's OK button
            unreachable. Deferring `open` until no image-proctoring modal is showing lets it
            appear right after the user dismisses whichever one got there first, instead of
            covering it. */}
        {/* <AudioAlertModal
          onConfirm={handleAudioConfirm}
          open={AudioAlertShowModal && !NoFaceAlertModal && !MultipleFaceAlertModal && !ObjectDetectedAlertModal && !LookingAwayAlertModal && !NoMatchAlertModal && !ImageAlertShowModal}
          count={AudioCount}
          audioAction={MonitoringData.result.audio_action}
        /> */}
        <NoFaceModal onConfirm={MonitoringData.result.photo_action === "S" ? handleConfirm : handleResumeTest} open={NoFaceAlertModal} isMongoUpdated={isMongoUpdated} examDetail={examDetail} faceNotFoundCount={faceNotFoundCount} MonitoringData={MonitoringData} />
        <MultipleFaceModal onConfirm={handleResumeTest} open={MultipleFaceAlertModal} isMongoUpdated={isMongoUpdated} />
        <NoMatchModal onConfirm={handleNoMatchOk} open={NoMatchAlertModal} />
        <ObjectDetectionModal onConfirm={handleResumeTest} open={ObjectDetectedAlertModal} isMongoUpdated={isMongoUpdated} objects={props.objectsDetected} />
        <LookingAwayModal onConfirm={handleResumeTest} open={LookingAwayAlertModal} isMongoUpdated={isMongoUpdated} />
        {/* Deferred the same way as AudioAlertModal above - if a face/object/match violation
            modal is already showing (which requires a captured frame, impossible while the
            camera is down) don't stack this on top of it. */}
        <CameraFailedModal
          open={cameraFailedModalOpen && !NoFaceAlertModal && !MultipleFaceAlertModal && !ObjectDetectedAlertModal && !LookingAwayAlertModal && !NoMatchAlertModal && !ImageAlertShowModal}
          terminal={cameraFailureTerminal}
          onRetry={handleRetryCamera}
          onGoToDashboard={handleCameraIncompatibleGoToDashboard}
        />
        <PhotoNotSentModal
          open={photoNotSent && !cameraFailedModalOpen && !NoFaceAlertModal && !MultipleFaceAlertModal && !ObjectDetectedAlertModal && !LookingAwayAlertModal && !NoMatchAlertModal && !ImageAlertShowModal}
          cause={photoNotSentCause}
          serverPauseState={serverPauseState}
          onGoToDashboard={handleServerPauseGoToDashboard}
        />
      </div>
    </>
  );
}

export default ImagEProctoring;
